import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let pending = null;

export const getAvailability = () => {
    if (!pending) {
        pending = axios
            .get(`${API}/availability`)
            .then((res) => res.data)
            .catch(() => ({ enabled: false }));
    }
    return pending;
};
